// 点击查看html中的图片的大图

import delegate from 'delegate';
import globalWin from '@/utils/globalWin.ts';

export default function viewHtmlImg(box, doms) {
  delegate(box, doms, 'click', (e) => {
    const img = e.delegateTarget;
    const src = img.getAttribute('src');
    globalWin.$ImageViewer.show({
      current: src,
      array: [src],
    });
  });
}
